import { useContext } from 'react';
import { PresentationPlayerContext } from '../../state/context/PresentationPlayerContext/PresentationPlayerContext';
export default function usePresentationPlayerContext() {
    const context = useContext(PresentationPlayerContext);
    if (!context) {
        throw new Error('usePresentationPlayer must be used within the PresentationPlayerProvider');
    }
    return context;
}
//# sourceMappingURL=usePresentationPlayerContext.js.map